import {GET_NOTIFICATIONS, MARK_AS_READ_NOTIFICATIONS, SET_NOTIFICATIONS} from "@/core/store/modules/notification/constants";
import api from "@/core/services/api/api.service";

export default {
    [GET_NOTIFICATIONS](context) {
        if (context.getters.isAuthenticated) {
            return new Promise((resolve, reject) => {
                api.get('/notifications').then(response => {
                    context.commit(SET_NOTIFICATIONS, response.data);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })

            })
        }
    },
    [MARK_AS_READ_NOTIFICATIONS](context, data) {
        return new Promise((resolve, reject) => {
            api.waiting('mark-as-read').post('/notifications/mark-as-read', data).then(response => {
                resolve(response)
                if (response.data.success){
                    context.dispatch(GET_NOTIFICATIONS)
                }
            }).catch(error => {
                reject(error)
            })

        })
    }
}